import React, {useEffect, useState} from 'react';
import {observer} from "mobx-react-lite";
import Seo from "../components/Seo";
import Header from "../components/Header";
import {useTranslation} from "react-i18next";

import img_telegram from '../img/telegram.png'
import cookie from "js-cookie";
import {useFetching} from "../hooks/useFetching";
import {API_CONTACTS_MAIL, API_CONTACTS_TEXT} from "../utils/consts";
import ApiContactsText from "../services/Contacts/Text";
import parse from "html-react-parser";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as yup from 'yup'
import ApiContactsMail from "../services/Contacts/Mail";
import TextareaAutosize from 'react-textarea-autosize';
import Loader from "../components/Loader";

const schema = yup.object().shape({
    name: yup.string().min(3).required(),
    phone: yup.string().matches(/^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/).required(),
    email: yup.string().email().required(),
    question: yup.string().min(10).required(),
});

const Input = ({label, name, register, defaultValue = '', type = 'text', error, setOpacity}) => {
    return (
        <>
            <input
                id={name}
                type={type}
                className={`field ${error ? 'required' : ''}`}
                placeholder={label}
                autoComplete="off"
                defaultValue={defaultValue}
                {...register(name, {
                    onChange: () => setOpacity(false)
                })}
            />
        </>
    )
};

const ContactsPage = () => {
    const {t} = useTranslation();
    const curr_lang = cookie.get('i18next');
    const [success, setSuccess] = useState();
    const [isLoading, setIsLoading] = useState(true);
    const [opacity, setOpacity] = useState(false);
    const [textAreaFocus, setTextAreaFocus] = useState(false);
    const [textAreaLength, setTextAreaLength] = useState(0);

    const [text, setText] = useState({});
    // const [text, setText] = useState({email: 'info@championstudio.net', address: 'CARRER DE LES BOЇGUES S/N EDIFICI PIC BLANC, DESPATX.109 Principat d\'Andorra', text: '<p>По любым вопросам Вы можете обращаться в нашу Службу Поддержки, через форму, что указана ниже:</p>'});

    const [FunctionApiContactsText] = useFetching(async () => {
        try {
            const response = await ApiContactsText.getApiContactsText(API_CONTACTS_TEXT);
            setText(response.data);
        } finally {
            setIsLoading(false)
        }
    });

    useEffect(() => {
        FunctionApiContactsText();
    }, [curr_lang]); // eslint-disable-line react-hooks/exhaustive-deps

    const {register, handleSubmit, formState: {errors, isValid}, reset, watch} = useForm({
        resolver: yupResolver(schema),
        mode: "onChange"
    });

    const [FunctionApiContactsMail] = useFetching(async (data) => {
        const response = await ApiContactsMail.postApiContactsMail(API_CONTACTS_MAIL, data);
        setSuccess(response.data.success);
        setOpacity(true);
    });

    const onSubmit = (data) => {
        FunctionApiContactsMail(data);
    };

    useEffect(() => {
        if (success) {
            reset();
        }
    }, [success, reset]);

    useEffect(() => {
        const subscription = watch((value, { name }) => {
            if (name === 'question') {
                setTextAreaLength(value.question.length)
            }
        });
        return () => subscription.unsubscribe();
    }, [watch]);

    return (
        <>
            {isLoading ? <Loader/> : <div className="contacts container_fluid">
                <Seo page='contacts'/>
                <div className="catalog background">
                    <Header/>
                    <div className="details_content content">
                        <div className="new_games">
                            <div className="up_catalog">
                                <div className="title_block">
                                    <h1>{t('Support & Contact')}</h1>
                                    {text && text.text && parse(text.text)}
                                </div>
                            </div>
                            <div className="contacts_block">
                                <div className="contacts_forms">
                                    <div className="msg" style={{opacity: opacity ? '1' : '0'}}>
                                        <p style={{color: success ? '#f1bc43' : '#c11929'}}
                                        >{success
                                            ? `${t('Thanks.')} ${t('We will contact you soon.')}`
                                            : `${t('Error.')} ${t('Please correct input data.')}`}</p>
                                    </div>
                                    <form>
                                        <Input register={register}
                                               label={t('Name')}
                                               name="name"
                                               error={errors?.name ? errors?.name : ''}
                                               setOpacity={setOpacity}
                                        />
                                        <Input register={register}
                                               label={t('Phone')}
                                               name="phone"
                                               error={errors?.phone ? errors?.phone : ''}
                                               setOpacity={setOpacity}
                                        />
                                        <Input register={register}
                                               label={t('E-mail')}
                                               name="email"
                                               error={errors?.email ? errors?.email : ''}
                                               setOpacity={setOpacity}
                                        />
                                        <TextareaAutosize
                                            id='question'
                                            autoComplete="nope"
                                            className={`field ${errors?.question ? 'required' : ''}`}
                                            defaultValue={''}
                                            placeholder={t('Question')}
                                            onFocus={() => setTextAreaFocus(true)}
                                            onBlurCapture={() => setTextAreaFocus(false)}
                                            rows="1"
                                            maxLength="500"
                                            {...register('question', {
                                                onChange: () => setOpacity(false)
                                            })}
                                        />
                                        {textAreaFocus && <div className="symbol_input">{textAreaLength > 0 ? 500 - textAreaLength : t('Не менше 10-ти символів')}</div>}
                                        <button
                                            disabled={!isValid}
                                            type="button"
                                            className="validateBtn"
                                            onClick={handleSubmit(onSubmit)}
                                        >
                                            <span>{t('SEND')}</span>
                                        </button>
                                    </form>
                                </div>
                                {(text && text.email) ? <div className="location">
                                    <div className="telegram">
                                        <img src={img_telegram} alt="telegram"/>
                                        <span>{`${t('Sent to our support')}: ${text.email}`}</span>
                                    </div>
                                </div> : null}
                            </div>
                        </div>
                    </div>
                </div>
            </div>}
        </>
    );
};

export default observer(ContactsPage);